import { useState } from "react";
import { httpsCallable } from "firebase/functions";
import { functions } from "../../firebase";
import AdminLayout from "./AdminLayout";
import "./AdminOutreach.css";

const generateOutreachDraftFn = httpsCallable(functions, "generateOutreachDraft");

const PLATFORMS = ["Instagram", "TikTok", "YouTube", "Other"];

export default function AdminOutreach() {
  const [name, setName] = useState("");
  const [handle, setHandle] = useState("");
  const [platform, setPlatform] = useState("Instagram");
  const [niche, setNiche] = useState("");
  const [followers, setFollowers] = useState("");
  const [contentDetail, setContentDetail] = useState("");
  const [draft, setDraft] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [copied, setCopied] = useState(false);

  const handleGenerate = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    setCopied(false);
    try {
      const { data } = await generateOutreachDraftFn({
        name: name.trim(),
        handle: handle.trim().replace(/^@/, ""),
        platform,
        niche: niche.trim(),
        followers: followers.trim(),
        contentDetail: contentDetail.trim(),
      });
      setDraft(data?.draft || data?.text || "");
    } catch (err) {
      setError(err.message || "Failed to generate draft.");
    } finally {
      setLoading(false);
    }
  };

  const handleCopy = async () => {
    if (!draft) return;
    try {
      await navigator.clipboard.writeText(draft);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      setError("Could not copy to clipboard.");
    }
  };

  return (
    <AdminLayout>
      <div className="admin-outreach-shell">
        <div className="admin-page-header">
          <div className="admin-eyebrow">Outreach</div>
          <div className="admin-page-title">Creator <em>Outreach</em></div>
          <span className="admin-page-hand">— draft a personal invite, then copy and send yourself</span>
        </div>

        <div className="admin-outreach-card">
          <form onSubmit={handleGenerate}>
            <div className="admin-outreach-grid">
              <div className="admin-outreach-field">
                <label htmlFor="outreach-name">Name</label>
                <input
                  id="outreach-name"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  placeholder="Anthea Wilson"
                  required
                />
              </div>
              <div className="admin-outreach-field">
                <label htmlFor="outreach-handle">Handle</label>
                <input
                  id="outreach-handle"
                  value={handle}
                  onChange={(e) => setHandle(e.target.value)}
                  placeholder="wing.it.beauty"
                  required
                />
              </div>
              <div className="admin-outreach-field">
                <label htmlFor="outreach-platform">Platform</label>
                <select id="outreach-platform" value={platform} onChange={(e) => setPlatform(e.target.value)}>
                  {PLATFORMS.map((p) => (
                    <option key={p} value={p}>{p}</option>
                  ))}
                </select>
              </div>
              <div className="admin-outreach-field">
                <label htmlFor="outreach-niche">Niche</label>
                <input
                  id="outreach-niche"
                  value={niche}
                  onChange={(e) => setNiche(e.target.value)}
                  placeholder="Wellness & Beauty"
                  required
                />
              </div>
              <div className="admin-outreach-field">
                <label htmlFor="outreach-followers">Followers</label>
                <input
                  id="outreach-followers"
                  value={followers}
                  onChange={(e) => setFollowers(e.target.value)}
                  placeholder="156K"
                />
              </div>
              <div className="admin-outreach-field full">
                <label htmlFor="outreach-content">Content detail</label>
                <textarea
                  id="outreach-content"
                  value={contentDetail}
                  onChange={(e) => setContentDetail(e.target.value)}
                  placeholder="Skincare routines, wellness rituals, product reviews…"
                  rows={4}
                  required
                />
              </div>
            </div>

            <div className="admin-outreach-actions">
              <button type="submit" className="admin-btn admin-btn-niche" disabled={loading}>
                {loading ? "Generating…" : "Generate Draft"}
              </button>
            </div>
          </form>

          {error && <div className="admin-outreach-error">{error}</div>}

          {draft && (
            <div className="admin-outreach-output">
              <div className="admin-ai-draft-label">✦ Outreach Draft</div>
              <div className="admin-outreach-draft">{draft}</div>
              <button type="button" className="admin-btn admin-btn-ghost" onClick={handleCopy}>
                {copied ? "Copied!" : "Copy"}
              </button>
            </div>
          )}
        </div>
      </div>
    </AdminLayout>
  );
}
